export default {
  GET_USER_NETWORK_SHARES: 'getUserNetworkShares',
  CONFIGURE_SHARE_USER: 'configureShareUser',
  SAVE_NETWORK_SHARE: 'saveNetworkShare',
  SAVE_NETWORK_SHARE_PERMISSION: 'saveNetworkSharePermission',
  FIND_NETWORK_DRIVE: 'findNetworkDrive',
  DELETE_NETWORK_SHARE_PERMISSION: 'deleteNetworkSharePermission',
  DELETE_NETWORK_SHARE: 'deleteNetworkShare'
}
